import React from 'react'
import { styled } from '@mui/material/styles'

export interface GradientTextProps extends React.ComponentPropsWithoutRef<'span'> {
  /** 'inline' for mid-sentence spans, 'eyebrow' for mono uppercase micro-labels */
  variant?: 'inline' | 'eyebrow'
}

const Root = styled('span', {
  shouldForwardProp: (p) => p !== 'variant',
})<{ variant: 'inline' | 'eyebrow' }>(({ variant }) => ({
  background: 'var(--ds-gradient-spectrum, var(--ds-ink))',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  color: 'transparent',
  ...(variant === 'eyebrow' && {
    fontFamily: 'var(--ds-font-mono)',
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
    background: 'linear-gradient(100deg, var(--ds-accent-deep-a, var(--ds-ink)), var(--ds-accent-deep-b, var(--ds-ink)))',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
  }),
}))

/** The one signature-gradient text treatment — "the Stripe move". Use sparingly, once per viewport. */
export function GradientText({ variant = 'inline', children, ...rest }: GradientTextProps) {
  return (
    <Root variant={variant} {...rest}>
      {children}
    </Root>
  )
}
